module.exports = __webpack_public_path__ + "img/UTDEER-1.d8c3df38.jpg";